import { useTelegram } from './UseTelegram';
import { RegisterChannel, RegisterChannelProps } from './RegisterChannel';
import { Spinner } from '../Components/Spinner';
import { TelegramConnectionStatus } from './TelegramConnectionStatus';

export function TelegramChannel(props: RegisterChannelProps) {
    const { authorized } = useTelegram(props);

    return (
        <div className='flex min-w-[216px] max-w-[216px] justify-center items-center'>
            {authorized === undefined && <Spinner className='m-auto' />}
            {authorized === false && <TelegramConnectionStatus connected={false} />}
            {authorized === true && <RegisterChannel {...props} />}
        </div>
    );
}
